export default "__VITE_ASSET__BzFy1z5C__"